import React from 'react';
import { GlobalStateProvider } from './GlobalStateContext';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import DemoComponent from './Components/DemoComponent/DemoComponent';

const theme = createTheme({
	typography: {
		fontFamily: [
			'"Satoshi"', 
			'"Roboto"', 
			'"Oxygen"', 
			'"Ubuntu"', 
			'"Cantarell"', 
			'"Fira Sans"', 
			'"Droid Sans"', 
			'"Helvetica Neue"', 
			'Arial', 
			'sans-serif',
		].join(','),
	},
});

const AppContent: React.FC = () => {
	return (
		<div className="App">
			<DemoComponent></DemoComponent>
		</div>
	);
};

const App: React.FC = () => {
	return (
		<GlobalStateProvider>
			<ThemeProvider theme={theme}>
				<AppContent />
			</ThemeProvider>
		</GlobalStateProvider>
	);
};



export default App;
